var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bar',{attrs:{"options":_vm.chartOptions,"data":_vm.chartData,"height":_vm.$vuetify.breakpoint.lgAndUp ? '60px' : '120px'}})
}
var staticRenderFns = []

export { render, staticRenderFns }